module.exports = __webpack_public_path__ + "img/shunsuke.5ad68766.jpg";